import cx from 'classnames';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  selectUserDisabled,
  selectUserOrSystemDisabled,
  TOGGLE_E_GIFT_CARDS_DRAWER,
  UPDATE_E_GIFT_CARD_RETAILER,
} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CheckmarkIcon} from '~library/svg/CheckmarkIcon';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {TrashIcon} from '~library/svg/TrashIcon';
import {emeraldWebText, mexicanOpalWebText, tanzanite} from '~libSass/base/_exports.sass';
import {RetailerImage} from './RetailerImage/RetailerImage';
import {ValueControl} from './ValueControl/ValueControl';
import './GiftCard.sass';

export const GiftCard = () => {
  const dispatch = useDispatch();
  const userDisabled = useSelector(selectUserDisabled);
  const userOrSystemDisabled = useSelector(selectUserOrSystemDisabled);

  const onClickChangeRetailerHandler = useCallback(() => {
    dispatch({type: TOGGLE_E_GIFT_CARDS_DRAWER, payload: true});
  }, [dispatch]);

  const onClickRemoveGiftCardHandler = useCallback(() => {
    dispatch({
      type: UPDATE_E_GIFT_CARD_RETAILER,
      payload: {
        // biome-ignore lint/style/useNamingConvention: existing error
        product_config_id: '',
        // biome-ignore lint/style/useNamingConvention: existing error
        product_config_name: '',
        image: '',
        value: 0,
      },
    });
  }, [dispatch]);

  return (
    <div className="gift-card-wrapper">
      {/* If removed card, hide button but still make it take up space  */}
      <Button
        className={cx('retailer-cta__change-retailer', {'retailer-cta__hidden': userDisabled})}
        data-qa-id="change-retailer-btn"
        variant="link"
        size="large"
        onClick={onClickChangeRetailerHandler}
        disabled={userOrSystemDisabled}
        icon={<ChevronIcon direction="left" ratio={0.75} color={tanzanite} />}
      >
        Change retailer
      </Button>
      <RetailerImage disabled={userOrSystemDisabled} />
      <ValueControl disabled={userOrSystemDisabled} />
      {userDisabled
        ? <Typography
            variant="paragraph2"
            className="retailer-cta__gift-card-removed"
            color="emeraldWebText"
          >
            <CheckmarkIcon ratio={0.75} color={emeraldWebText} />
            eGift Card removed
          </Typography>
        : <Button
            className="retailer-cta__remove-gift-card"
            data-qa-id="remove-gift-card-btn"
            variant="transparent"
            size="large"
            onClick={onClickRemoveGiftCardHandler}
            disabled={userOrSystemDisabled}
            icon={<TrashIcon ratio={0.625} color={mexicanOpalWebText} />}
          >
            Remove eGift Card
          </Button>}
    </div>
  );
};
